import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
// import imgSrc1 from "@/assets/images/greatfox.jpg";
import imgSrc2 from "@/assets/images/ant.jpg";

Vue.use(Vuex);
let host = "http://admin-api.sdk.dev.mayigames.com/";
let title = "游戏发行平台";
let imgSrc = "";
let ico_url = "";
let logoText = "HH"
let platform = "my"

// switch (process.env.VUE_APP_ENV) {
//   case "fox":
//     host = "http://fox-admin-api.sdk.mayigames.com/";
//     break;
//   case "ant":
//     host = "http://admin-api.sdk.mayigames.com/";
//     title = "蚂蚁游戏发行平台";
//     imgSrc = imgSrc2;
//     ico_url = "../../public/ant.ico";
//     logoText = "MY";
//     platform = "my";
//     break;
//   case "bear":
//     host = "http://admin-api.sdk.beargames.cn/";
//     title = "水熊游戏发行平台";
//     // imgSrc = imgSrc2;
//     // ico_url = "../../public/ant.ico";
//     logoText = "BEAR";
//     platform = "sx";
//     break;
//   case "jb":
//     host = "http://jb-admin-api.sdk.rotifer.cn/";
//     title = "机暴游戏发行平台";
//     logoText = "JB";
//     platform = "jb";
//     break;
//   default:
//     host = "http://admin-api.sdk.dev.mayigames.com/";
//     // host="http://ymy_laravel_admin.vaiwan.com/"
//     // host = "http://laravel-admin.test"
//     break;
// }

var link =
  document.querySelector("link[rel*='icon']") || document.createElement("link");
link.type = "image/x-icon";
link.rel = "shortcut icon";
link.href = ico_url;
document.getElementsByTagName("head")[0].appendChild(link);

let platformUserList = []
if (localStorage.getItem('PLATFORM_USER_LIST')) {
  platformUserList = JSON.parse(localStorage.getItem('PLATFORM_USER_LIST'))
}
let currentPlatformUser = {}
if (localStorage.getItem('PLATFORM_USER')) {
  currentPlatformUser = JSON.parse(localStorage.getItem('PLATFORM_USER'))
  const {
    access_token,
    access_token_expired_at,
    super_token,
    super_token_expired_at
  } = currentPlatformUser
  host = currentPlatformUser.host
  platform = currentPlatformUser.value
  logoText = currentPlatformUser.label
  sessionStorage.setItem(
    "access_token",
    access_token
  )
  sessionStorage.setItem(
    "access_token_expired_at",
    access_token_expired_at
  )
  if (super_token && super_token_expired_at) {
    localStorage.setItem(
      "super_token",
      super_token
    )
    localStorage.setItem(
      "super_token_expired_att",
      super_token_expired_at
    )
  }
}

const store = new Vuex.Store({
  state: {
    showLogin: false,
    currentPlatformUser,
    platformUserList,
    host: host,
    title: title,
    imgSrc: imgSrc,
    logoText:logoText,
    platform: platform,
    admin: sessionStorage.getItem("admin")
      ? JSON.parse(sessionStorage.getItem("admin"))
      : {},
    permissions: [],
    showGamePackagesUploadTasks: false,
    gamePackagesUploadTasks: [],
    companiesList: [],
    MAGIC: 0,
    exportDownloadPercent: null,
  },
  mutations: {
    setExportDownloadPercent(state, data) {
      state.exportDownloadPercent = data;
    },
    // 添加参数
    addCurrentUserParams (state, data) {
      const target = {
        ...state.currentPlatformUser,
        ...data
      }
      state.currentPlatformUser = target
      const findIndex = state.platformUserList.findIndex(item => item.value === target.value && item.id === target.id)
      if (findIndex !== -1) {
        state.platformUserList[findIndex] = target
      }
    },
    toggleLogin (state) {
      this.commit('removeUser')
      const platformUserList = state.platformUserList
      if (platformUserList && platformUserList.length) {
        this.commit('setCurrentPlatform', platformUserList[0])
        state.showLogin = !state.showLogin
      } else {
        router.push("/");
      }
    },
    // 添加主体账号
    setPlatformList (state, data) {
      const findIndex = data && data.value
                      && state.platformUserList.findIndex(item => item.value === data.value && item.id === data.id)
      this.commit('setCurrentPlatform', data)
      if (findIndex === -1) {
        state.platformUserList.push(data)
      } else {
        state.platformUserList[findIndex] = data
      }
      localStorage.setItem('PLATFORM_USER_LIST', JSON.stringify(state.platformUserList))
    },
    // 更新账号token
    updateLogin (state, data) {
      const userData = state.currentPlatformUser
      const findIndex = userData && userData.value
                      && state.platformUserList.findIndex(item => item.value === userData.value && item.id === userData.id)
      if (findIndex !== -1) {
        state.currentPlatformUser.access_token = data.access_token
        state.currentPlatformUser.access_token_expired_at = data.expired_at
        localStorage.setItem('PLATFORM_USER', JSON.stringify(state.currentPlatformUser))
        state.platformUserList[findIndex] = state.currentPlatformUser
        localStorage.setItem('PLATFORM_USER_LIST', JSON.stringify(state.platformUserList))
      }
    },
    removeUser (state) {
      const userData = state.currentPlatformUser
      const findList = userData && userData.value
                      && state.platformUserList.filter(item => item.value !== userData.value || item.id !== userData.id)
      if (findList) {
        state.currentPlatformUser = {}
        localStorage.removeItem('PLATFORM_USER')
        state.platformUserList = findList
        localStorage.setItem('PLATFORM_USER_LIST', JSON.stringify(findList))
      }
    },
    // 更换选中主体
    setCurrentPlatform (state, data) {
      this.commit('setPlatform', data)
      state.currentPlatformUser = data
      this.commit('setCompaniesList', data.companies || '')
      sessionStorage.setItem("access_token", data.access_token)
      sessionStorage.setItem("access_token_expired_at", data.access_token_expired_at)
      localStorage.setItem('PLATFORM_USER', JSON.stringify(data))
      localStorage.setItem('PLATFORM_USER_LIST', JSON.stringify(state.platformUserList))
      if (data.super_token && data.super_token_expired_at) {
        localStorage.setItem(
          "super_token",
          data.super_token
        )
        localStorage.setItem(
          "super_token_expired_att",
          data.super_token_expired_at
        )
      } else {
        localStorage.removeItem("super_token")
        localStorage.removeItem("super_token_expired_att")
      }
      router.push(data.lastRoute || '/home/index')
    },
    // 登录更换主体
    setPlatform (state, data) {
      state.host = data.host
      state.platform = data.platform || data.value
      state.logoText = data.label
    },
    setAdmin(state, data) {
      state.admin = data;
    },
    setPermissions(state, data) {
      state.permissions = data;
    },
    addTasks(state, data) {
      const existTarget = state.gamePackagesUploadTasks.find(item => item.id === data.id)
      if (!existTarget) state.gamePackagesUploadTasks.push(data)
    },
    removeTasks(state, taskId) {
      let removeIndex = -1
      state.gamePackagesUploadTasks.forEach((item, index) => {
        if(item.taskId == taskId) {
          removeIndex = index
        }
      })

      state.gamePackagesUploadTasks.splice(removeIndex, 1)
    },
    changeShowGamePackagesUploadTasks(state, show) {
      state.showGamePackagesUploadTasks = show
    },
    changeTask(state, task) {
      state.gamePackagesUploadTasks.forEach((item, index) => {
        if(item.taskId == task.taskId) {
          state.gamePackagesUploadTasks[index] = task
        }
      })
    },
    // 设置关联主体
    setCompaniesList (state, companies) {
      let companiesList = companies ? companies.split(',') : []
      if (state.currentPlatformUser
        && state.currentPlatformUser.role_id
        && state.currentPlatformUser.role_id === 1) companiesList = ['my', 'sx', 'jb', 'fox', 'lc']
      state.companiesList = companiesList
    },
    // 
    setMAGIC (state, data) {
      state.MAGIC = data === '1' ? 1 : 0
    }
  },

  actions: {
    // hasPermission(state, permission) {
    //   if(state.permissions.indexOf(permission) != -1) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  modules: {},
});
Vue.prototype.hasPermission = function(permission) {
  return store.state.permissions.indexOf(permission) !== -1;
};
export default store;
